import React, { createContext, MutableRefObject, PropsWithChildren, useRef } from 'react';
import { Group, Object3D } from 'three';

export const SceneContext = createContext<null | MutableRefObject<Object3D | Group | null>>(null);
export const SceneProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const activeObject = useRef<Object3D | Group | null>(null);
    return <SceneContext.Provider value={activeObject}>{children}</SceneContext.Provider>
};